import { Flex, Button } from '@infotrack/zenith-ui';
import { actionButtonsStyles } from './topFiveItem.styles';
import type { TopFiveItemType } from '@/api/types/topFiveItemType';

type TopFiveItemActionsProps = {
  item: TopFiveItemType;
  hasTeamMembers: boolean;
  isExpanded: boolean;
  onActionClick?: (
    action: 'comment' | 'history' | 'group',
    item: TopFiveItemType
  ) => void;
};

export const TopFiveItemActions = ({
  item,
  hasTeamMembers,
  isExpanded,
  onActionClick,
}: TopFiveItemActionsProps) => (
  <Flex sx={actionButtonsStyles}>
    <Button
      iconProps={{ name: 'comment', variant: 'outlined' }}
      variant="borderless"
      size="small"
      onClick={() => onActionClick?.('comment', item)}
      aria-label="View comments"
    />
    <Button
      iconProps={{ name: 'history', variant: 'outlined' }}
      variant="borderless"
      size="small"
      onClick={() => onActionClick?.('history', item)}
      aria-label="View history"
    />
    <Button
      iconProps={{ name: 'group', variant: 'outlined' }}
      variant="borderless"
      size="small"
      onClick={() => onActionClick?.('group', item)}
      aria-label={isExpanded ? 'Hide team' : 'View team'}
      disabled={!hasTeamMembers}
    />
  </Flex>
);
